export default function formDownload() {
    const forms = document.getElementsByClassName('form-download__form');
    // Loop over them and prevent submission
    // eslint-disable-next-line no-unused-vars
    const validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            event.stopPropagation();
            form.classList.add('was-validated');
            const fieldset = form.querySelector('.form-download__fieldset');

            if (form.checkValidity() !== false) {
                fieldset.setAttribute('disabled', true);

                const data = {
                    'Name': form.querySelector('#firstName').value,
                    'LastName': form.querySelector('#lastName').value,
                    'JobTitle': form.querySelector('#jobTitle').value,
                    'Email': form.querySelector('#businessEmailAddress').value,
                    'Company': form.querySelector('#companyName').value,
                    'ReceiveOtherCommunicationFromOritain': form.querySelector('#optIn').value,
                };

                $.ajax({
                    method: "POST",
                    url: form.action,
                    data: data
                }).done(function(msg) {
                    if (msg === 'success') {
                        form.classList.add('success');
                    } else {
                        fieldset.setAttribute('disabled', false);
                    }
                });
            }
        }, false);
    });
}
